// External libraries
import { css } from '@emotion/core';

const interstitialHeaderStyleOverrides = css`
  justify-content: flex-end;
  margin: 0 auto;
  max-width: 1150px;
  padding-bottom: 0;
`;

const interstitialStyleOverrides = css`
  border-radius: 0;
  max-width: 100vw;
  padding: 0 30px;
  width: 100vw;
`;

export { interstitialHeaderStyleOverrides, interstitialStyleOverrides };
